import { useState } from 'react'
import { Toaster } from 'react-hot-toast';
import {  onMessageListener } from './firebase.js';
import UIfx from 'uifx'
import bellAudio from '../assets/bell.mp3'

const Notification = () => {
  const [notification, setNotification] = useState({ title: '', body: '', url: '' });
  // const notify = () => toast(<ToastDisplay />);
  console.log(notification)




  onMessageListener()
    .then((payload) => {
      const bell = new UIfx(
        bellAudio,
        {
          volume: 0.4, // number between 0.0 ~ 1.0
          throttleMs: 100
        }
      )
      bell.play()
      setNotification({ title: payload?.data?.title, body: payload?.data?.body, url: payload?.data?.url });
    })
    .catch((err) => console.log('failed: ', err));

  return (
    <Toaster toastOptions={{
      // Define default options
      className: '',
      duration: 3000000,
      style: {
        background: '#3c0e0e',
        color: '#fff',
      }
    }}
    />
  )
}

export default Notification